import { Component, inject } from '@angular/core';

import { trackByIndex } from '@core/common-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

import { FeatureItemComponent } from '../feature-item/feature-item.component';

@Component({
  selector: 'rt-plan-picker-2024-footer',
  templateUrl: './plan-picker-2024-footer.component.html',
  styleUrls: ['./plan-picker-2024-footer.component.less'],
  imports: [FeatureItemComponent, TranslatePipe],
})
export class PlanPicker2024FooterComponent {
  private readonly i18n = inject(I18nService);

  public readonly model = {
    left: [
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.user_access.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.user_access.tooltip'),
      },
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.compliance.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.compliance.tooltip'),
      },
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.gdpr.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.gdpr.tooltip'),
      },
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.iso.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.iso.tooltip'),
      },
    ],
    right: [
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.mobile.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.mobile.tooltip'),
      },
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.api.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.api.tooltip'),
      },
      {
        label: this.i18n.translate('app.pricing.plan_picker_2024.footer.marketplace.label'),
        tooltip: this.i18n.translate('app.pricing.plan_picker_2024.footer.marketplace.tooltip'),
      },
    ],
  };
  public readonly trackByIndex = trackByIndex;
}
